module.exports = __webpack_public_path__ + "static/media/LogoMenoQ.889fc0e5.svg";